import React, { forwardRef } from 'react';
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
import logo from '../../../images/logo-s.png';
import qa_image from '../../../images/logo-s.png';
import qoiImg from '../../../images/print_header.png';
import styles from '.././../../styles.module.css';
import trigaslogo from "../../../images/tri_gases.jpeg";

const GRNPrint = forwardRef(({ printDetails }, ref) => {

    const printData = printDetails;
    // Parse grn_details if it's a string
    let childRows = [];
    if (typeof printData.grn_details === 'string') {
        try {
            childRows = JSON.parse(printData.grn_details);
        } catch (e) {
            childRows = [];
        }
    } else if (Array.isArray(printData.grn_details)) {
        childRows = printData.grn_details;
    }
    const dateConversion = (date) => {
        if (!date) return '-';
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };

    return (
        <>

            <Box className="print-source" style={{ margin: '30px' }}  >
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff' }}>
                    <Grid container sx={{}}>
                        <Grid item xs={12} style={{
                            backgroundImage: `url(${qoiImg})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '60px',
                            marginBottom: '8px'
                        }}>
                            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                                <Typography sx={{ textAlign: 'start', marginLeft: '50px', marginTop: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff' }}>
                                    GOODS RECEIPT NOTE
                                </Typography>
                                <img src={trigaslogo} style={{ width: 'auto', height: '50px', marginTop: '5px', borderRadius: '2px', border: '2px solid #e10a0a' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} >
                            <Grid container>
                                <Grid item xs={8} >
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                        CYLINDER TRACKING SYSTEM (I) Pvt. Ltd.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        {printData.delivery_address}
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Telefax -
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Email - test1962@gmail.com
                                    </Typography>

                                </Grid>
                                <Grid item xs={4} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}>
                                    {/* <img src={qa_image} style={{ width: 'auto', height: '60px', borderRadius: '4px' }} /> */}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px' }}>

                        </Grid>
                    </Grid>
                    <Grid >
                        <Grid item xs={7} >
                            <Box sx={{ minHeight: '20px', margin: '1px', marginLeft: '0px', textAlign: 'left', }}>
                                <Typography sx={{ fontSize: '18px', fontWeight: 'bold', }}>
                                    {printData.customer_name}
                                </Typography>
                                <Typography sx={{ fontSize: '12px', }}>
                                    {printData.customer_address}
                                </Typography>
                            </Box>
                        </Grid>
                        {/* <Grid item xs={5}> */}
                            <Grid container spacing={2}>
                                {/* LEFT COLUMN: 5 fields */}
                                <Grid item xs={6}>
                                    <Grid container>
                                        {[
                                            { label: 'RFQ No', value: printData.rfq_no },
                                            { label: 'Invoice No', value: printData.invoice_no },
                                            { label: 'Invoice Date', value: dateConversion(printData.invoice_date) },
                                            { label: 'Challan No', value: printData.challan_no },
                                            { label: 'Challan Date', value: dateConversion(printData.challan_date) },
                                        ].map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Grid item xs={4.5}>
                                                    <Box sx={{ margin: '6px', textAlign: 'left' }}>
                                                        <Typography className={styles.info_txt}>{item.label}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={0.5}>
                                                    <Box sx={{ margin: '6px', textAlign: 'center' }}>
                                                        <Typography className={styles.info_txt}>:</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Box sx={{ margin: '6px', textAlign: 'right' }}>
                                                        <Typography className={styles.info_txt_ans}>{item.value}</Typography>
                                                    </Box>
                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </Grid>

                                {/* RIGHT COLUMN: 4 fields */}
                                <Grid item xs={6}>
                                    <Grid container>
                                        {[
                                            { label: 'LR No', value: printData.lr_no },
                                            { label: 'Transporter', value: printData.transporter },
                                            { label: 'Vehicle No', value: printData.vehicle_no },
                                            { label: 'Driver', value: printData.driver_name },
                                        ].map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Grid item xs={4.5}>
                                                    <Box sx={{ margin: '6px', textAlign: 'left' }}>
                                                        <Typography className={styles.info_txt}>{item.label}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={0.5}>
                                                    <Box sx={{ margin: '6px', textAlign: 'center' }}>
                                                        <Typography className={styles.info_txt}>:</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Box sx={{ margin: '6px', textAlign: 'right' }}>
                                                        <Typography className={styles.info_txt_ans}>{item.value}</Typography>
                                                    </Box>
                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>

                        {/* </Grid> */}

                        <Grid item xs={12} >

                        </Grid>
                    </Grid>
                    <Box style={{ height: '20px' }}> </Box>
                    <TableContainer sx={{ minWidth: 650, minHeight: 280, padding: '0px 1px 0px 1px' }}>
                        <Table size="small" style={{ borderCollapse: 'collapse' }}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCellPrint align="center">Sr. No.</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left">PO No/Date</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left">Item Code</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left">Item Description</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left">Dept/Unit</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left">UOM</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Challan Qty</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Received Qty</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Short Qty</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Excess Qty</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Rejected Qty</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Accepted Qty</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Unit Rate</StyledTableCellPrint>
                                    <StyledTableCellPrint align="right">Amount</StyledTableCellPrint>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(childRows) && childRows.map((row, idx) => (
                                    <StyledTableRow key={idx}>
                                        <StyledTableCellPrint align="center">{row.srno || idx + 1}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">{row.po_no_date}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">{row.item_code}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">{row.item_description}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">{row.dept_unit}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">{row.uom}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.challan_qty}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.recived_qty}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.short_qty}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.excess_qty}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.rejected_qty}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.accepted_qty}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.unit_rate}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right">{row.amount}</StyledTableCellPrint>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ textAlign: 'left', marginTop: 2 }}>
                        <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                            Certificate No: {printData.certificate_no}
                        </Typography>
                        {printData.upload_certificate && (
                            <Typography sx={{ fontSize: '12px' }}>
                                Certificate: <a href={printData.upload_certificate} target="_blank" rel="noopener noreferrer">View</a>
                            </Typography>
                        )}
                        {printData.upload_invoice && (
                            <Typography sx={{ fontSize: '12px' }}>
                                Invoice: <a href={printData.upload_invoice} target="_blank" rel="noopener noreferrer">View</a>
                            </Typography>
                        )}
                        {printData.upload_challan && (
                            <Typography sx={{ fontSize: '12px' }}>
                                Challan: <a href={printData.upload_challan} target="_blank" rel="noopener noreferrer">View</a>
                            </Typography>
                        )}
                        {printData.upload_lr && (
                            <Typography sx={{ fontSize: '12px' }}>
                                LR: <a href={printData.upload_lr} target="_blank" rel="noopener noreferrer">View</a>
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ textAlign: 'right', marginTop: 4 }}>
                        <Typography sx={{ fontSize: '12px' }}>
                            For <b>CYLINDER TRACKING SYSTEM (I) Pvt Ltd</b>
                        </Typography>
                        <Typography sx={{ fontSize: '12px' }}>
                            Authorized Signatory
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        </>
    );
});

export default GRNPrint;
